import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Details, { mapByRefValue } from '../../Details/Details/Details';
import { getOldRequest } from '../../Services/httpCalls';
import Loader from '../../UIComponents/Loader';
import { personalData } from '../../helperFuncs';
import RoundedButton from '../../UIComponents/Buttons/RoundedButton';
import PDFViewer from '../../UIComponents/PDFViewer';

const OldRegistrationPreview = () => {
  const [oldRequest, setOldRequest] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [fileContent, setFileContent] = useState();
  const [openFile, setOpenFile] = useState(false);
  const hasValue = (value) => value !== null && value !== undefined;
  const { id } = useParams();

  useEffect(() => {
    const fetchOldRequests = async () => {
      setIsLoading(true);
      try {
        const response = await getOldRequest();
        setOldRequest(
          response?.data?.old_requests?.find(
            (r) => String(r.id) === String(id),
          ) ?? null,
        );
      } catch (error) {
        console.error('Failed to fetch old requests', error);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchOldRequests();
  }, [id]);

  const mappedBasicData = [
    ...(hasValue(oldRequest?.protocol)
      ? [
          {
            name: 'Αρ.πρωτοκολλου',
            refValue: 'protocol',
            id: 1,
            value: oldRequest?.protocol,
          },
        ]
      : []),
    ...(hasValue(oldRequest?.submit_date)
      ? [
          {
            name: 'Ημερομηνία υποβολής',
            refValue: 'creation_date',
            id: 1,
            value: oldRequest?.submit_date,
          },
        ]
      : []),
  ];

  const mappedPersonalData =
    (oldRequest &&
      mapByRefValue(oldRequest, personalData).filter(({ value }) =>
        hasValue(value),
      )) ||
    [];

  const mappedCommunicationData = [
    ...(hasValue(oldRequest?.email)
      ? [
          {
            name: 'Εmail',
            refValue: 'email',
            id: 1,
            value: oldRequest?.email,
          },
        ]
      : []),
    ...(hasValue(oldRequest?.mobile)
      ? [
          {
            name: 'Κινητό τηλέφωνο',
            refValue: 'mobile',
            id: 1,
            value: oldRequest?.mobile,
          },
        ]
      : []),
  ];

  const mappedProfesionalData = [
    ...(hasValue(oldRequest?.speacialty_description)
      ? [
          {
            name: 'Ειδικότητα/ Επάγγελμα',
            refValue: 'profession',
            id: 1,
            value: oldRequest?.speacialty_description,
          },
        ]
      : []),
    ...(hasValue(oldRequest?.file_content)
      ? [
          {
            name: 'Τεκμηρίωση επαγγέλματος/ειδικότητας',
            refValue: 'degree',
            id: 1,
            value: (
              <RoundedButton
                color="success"
                variant="contained"
                onClick={() => {
                  setFileContent(oldRequest.file_content);
                  setOpenFile(true);
                }}
              >
                {' '}
                {oldRequest?.file_name ?? 'Αρχείο'}
              </RoundedButton>
            ),
          },
        ]
      : []),
  ];
  return (
    <Box>
      <Typography sx={{ my: 3 }}>
        Υπεύθυνη δήλωση απογραφής στο μητρώο καλλιτεχνών, δημιουργών και
        επαγγελματιών της τέχνης και του πολιτισμού
      </Typography>
      <Typography variant="h1" sx={{ my: 3 }}>
        Προβολή
      </Typography>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <Typography variant="h3" sx={{ my: 3 }}>
            Βασικά στοιχεία αίτησης
          </Typography>
          <Details id={'requestData'} rows={mappedBasicData} />
          <Typography variant="h3" sx={{ my: 3 }}>
            Προσωπικά στοιχεία
          </Typography>
          <Details id={'personalData'} rows={mappedPersonalData} />
          <Typography variant="h3" sx={{ my: 3 }}>
            Στοιχεία επικοινωνίας
          </Typography>
          <Details id={'CommunicationData'} rows={mappedCommunicationData} />
          <Typography variant="h3" sx={{ my: 3 }}>
            Στοιχεία Δραστηριοποίησης
          </Typography>
          <Details id={'ProfesionalData'} rows={mappedProfesionalData} />
        </Box>
      )}
      {openFile && (
        <PDFViewer
          data={fileContent}
          setIsShownModal={setOpenFile}
          open={openFile}
        />
      )}
    </Box>
  );
};
export default OldRegistrationPreview;
